module.exports = __webpack_public_path__ + "static/media/Follo_annonceur.4bd27293.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/follo/fr/Follo_annonceur.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/follo/fr/Follo_annonceur.pdf
// module chunks = 18